import { SET_BANNERS, SetBannersAction } from './actions';
import { BannersState } from './types';

const initialState: BannersState = {
	banners: [],
	lastFetched: null,
};

type BannersAction = SetBannersAction;
export default function bannersReducer(state = initialState, action: BannersAction): BannersState {
	if (action.type === SET_BANNERS) {
		return action.payload;
	}

	return state;
}
